module.exports = __webpack_public_path__ + "static/media/public-relations.4a4e7a16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/public-relations.svg
// module id = 320
// module chunks = 0